import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { useConfig } from '@atlassiansox/bxp-content-framework';
import { useMember } from './use-member';
import { getCookie } from '../../utils';
export const OnetrustContext = createContext({
    hasOptedOut: true,
    privacyLink: _jsx(_Fragment, {}, void 0)
});
export const useOnetrust = () => {
    const context = useContext(OnetrustContext);
    if (context === undefined) {
        throw new Error('`useOnetrust` must be used within a `Onetrust.Provider`');
    }
    return context;
};
export const OnetrustProvider = ({ children }) => {
    const { environment } = useConfig();
    const member = useMember();
    const [hasOptedOut, setHasOptedOut] = useState(true);
    const privacyLink = (_jsx("li", Object.assign({ className: "atl-policy-link-container" }, { children: _jsx("a", Object.assign({ href: "http://", className: "atl-policy-link atl-policy-link-text" }, { children: "Notice at Collection" }), void 0) }), void 0));
    useEffect(() => {
        // to be removed when the migration to cloud.session.token is complete
        if (member.status === 'pending')
            return;
        if (member.status === 'resolved') {
            window.OTWrapperGetIdentifier = () => {
                return member.value.aaId;
            };
        }
        const optanonConsentCookieValue = getCookie('OptanonConsent');
        setHasOptedOut(optanonConsentCookieValue
            ? optanonConsentCookieValue.includes(',2:0')
            : false);
        if (!document.head.querySelector('#Onetrust')) {
            const scriptId = 'Onetrust';
            const script = document.createElement('script');
            script.async = true;
            script.type = 'text/javascript';
            script.id = scriptId;
            if (environment === 'production') {
                script.src =
                    'https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js';
                script.setAttribute('data-domain', 'dcb287ca-43c0-462c-a090-46b2debf69e2');
                script.setAttribute('data-test', 'false');
            }
            else {
                script.src =
                    'https://atl-onetrust-wrapper.stg-east.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
                script.setAttribute('data-domain', 'dc680e5f-1f51-48c1-8bd3-d6db0aeece4a');
                script.setAttribute('data-test', 'true');
            }
            script.setAttribute('data-geofence', 'false');
            script.setAttribute('data-sync', 'true');
            document.head.appendChild(script);
        }
    }, [environment, member, hasOptedOut]);
    return (_jsx(OnetrustContext.Provider, Object.assign({ value: { hasOptedOut, privacyLink } }, { children: children }), void 0));
};
//# sourceMappingURL=use-onetrust.js.map